<div class="main-container" data-cy="patient-portal-forms-main-container">
  <div class="action-container" data-cy="patient-portal-forms-action-container">
    <button mat-button (click)="goBack()" data-cy="patient-portal-forms-back-action-button"> <i class="material-icons" data-cy="patient-portal-forms-back-action-icon">keyboard_backspace </i></button>
  </div>
  <div class="form-container" data-cy="patient-portal-forms-form-container">
    <app-forms-form [absolutePosition]="true" [CaseWorkItemFormsId]="FormId" data-cy="patient-portal-forms-app-forms-form"></app-forms-form>
  </div>  
</div>
